/* Native cart (blueprint §3) */
(() => {
'use strict';
if (window.BBCart) return;
const d = document, W = window,
  $ = (s, r) => (r || d).querySelector(s),
  $$ = (s, r) => [...(r || d).querySelectorAll(s)],
  at = (e, a) => e.getAttribute(a),
  kin = (x, k) => $$('[data-bb-focus]', x).filter(e => at(e, 'data-bb-focus').startsWith(k)),
  norm = s => String(s ?? '').trim().toLowerCase(),
  mk = (t, c, x) => { const e = d.createElement(t); e.className = c; e.textContent = x; return e; },
  say = (e, t) => { if (e) { e.textContent = t; e.hidden = !t; } };
function pick(nodes, o = {}) {
  const t = norm(o.anchorType), al = {}, seen = [String(o.anchorId), ...(o.exclude || []).map(String)], out = [];
  String(o.aliases || '').split(';').forEach(p => {
    const [a, b] = p.split('>').map(norm);
    if (a && b) (al[a] = al[a] || []).push(b);
  });
  const ok = t && [t, ...(al[t] || [])];
  for (const n of nodes || []) {
    const id = at(n, 'data-product-id');
    if (out.length >= (o.max || 1 / 0)) break;
    if (seen.includes(id) || ok && !ok.includes(norm(at(n, 'data-type')))) continue;
    seen.push(id);
    out.push(n);
  }
  return out;
}
function vSync(s, user) {
  const r = s.closest('[data-bb-variant-root]'), o = s.options[s.selectedIndex];
  if (!r) return;
  if (user) {
    if (s.closest('[data-bb-rec]')) s.setAttribute('data-touched', '');
    say($('[data-bb-claim-error],[data-bb-rec-error]', r), '');
  }
  if (!o) return;
  const p = at(r, 'data-bb-variant-root'), pr = $('[data-bb-variant-price]', r), c = at(o, 'data-compare'),
    src = at(o, 'data-image'), img = $('[data-bb-variant-img]', r);
  if (pr && o.hasAttribute('data-price')) pr.replaceChildren(mk('span', p + '__amount' + (c ? ` ${p}__amount--sale` : ''), at(o, 'data-price')), ...(c ? [mk('s', p + '__compare', c)] : []));
  if (src && img && (user || !o.defaultSelected)) { img.src = src; img.removeAttribute('srcset'); }
}
function match(root, a) {
  if (root && a) $$('[data-bb-variant-select]', root).forEach(s => {
    if (s.hasAttribute('data-touched')) return;
    const os = [...s.options].filter(x => !x.disabled), f = (k, v) => v != null && os.find(x => at(x, k) === String(v)),
      o = f('data-title', a.title) || f('data-option1', a.option1);
    if (o) s.value = o.value;
    vSync(s);
  });
}

let cfg;
try { cfg = JSON.parse($('#bb-cart-config').textContent); } catch {}
if (!cfg || cfg.enabled === false) return;
const R = cfg.routes, C = cfg.copy, rc = cfg.recs, secs = cfg.sections, page = cfg.cartPage, ctx = page ? 'page' : 'drawer', ids = secs[ctx],
  SHOP = /^(form|claim|recs|stepper|bundle|clips|link)/,
  LOC = '^(/[a-z]{2}(-[a-z]{2})?)?/cart', ADD = RegExp(LOC + '/add(\\.js)?$'), CART = RegExp(LOC + '/?$'), VERB = RegExp(LOC + '/(add|change)$'),
  emit = (n, x) => d.dispatchEvent(new CustomEvent(n, {detail: x})),
  rebuy = () => !!W.Rebuy?.SmartCart,
  loop = () => !!W.LoopOnstore?.isActive?.(),
  rootEl = () => $(`[data-bb-cart-root][data-context="${ctx}"]`),
  dlg = () => $('[data-bb-cart-dialog]'),
  parts = k => S.lines.filter(l => l.key === k),
  sumQ = ls => ls.reduce((n, l) => n + (+l.qty || 0), 0),
  wait = ms => new Promise(r => setTimeout(r, ms)),
  cartSig = () => [S.itemCount, S.totalPrice, S.lines.map(l => l.key).sort()].join('|'),
  qmap = () => S.lines.reduce((m, l) => (m[l.variantId] = (m[l.variantId] || 0) + (+l.qty || 0), m), {}),
  stampDue = () => cfg.stamp && !stamped && S.itemCount > 0 && !S.attrs.bbCart;
let S, notice, buf = [], lastSync = Date.now(), lastAdd = 0, stamped, hidden, q = Promise.resolve(), pending = 0,
  jobAC, shown, obsT = 0, obsN = 0, obsOpen, trig, ckText, recAC, recKey, recWarned, warned, gen = 0, slid;
const recCache = new Map(), errs = new WeakMap();

function parse(r) {
  let s = {itemCount: r ? +at(r, 'data-bb-item-count') || 0 : 0};
  try { s = JSON.parse($('[data-bb-cart-state]', r).textContent); } catch {}
  return {lines: [], bands: {}, attrs: {}, recs: {}, gift: {}, ...s};
}
function announce(t, first) {
  if (!t || buf[first ? 'unshift' : 'push'](t) > 1) return;
  requestAnimationFrame(() => {
    const r = $(`[data-bb-cart-live="${isOpen() || page ? 'in' : 'out'}"]`);
    if (r) r.textContent = '';
    requestAnimationFrame(() => { if (r) r.textContent = buf.join(' '); buf = []; });
  });
}
const showNotice = r => say($('[data-bb-cart-notice]', r || rootEl()), notice ? notice.text : '');
const clearNotice = src => { if (notice && SHOP.test(src)) { notice = null; showNotice(); } };

function swap(h, src) {
  const nx = new DOMParser().parseFromString(h, 'text/html').querySelector('[data-bb-cart-root]'), cur = rootEl();
  if (!nx || !cur) return;
  const ae = d.activeElement, had = cur.contains(ae) || ae == d.body && isOpen(), fk = had && at(ae, 'data-bb-focus') || '',
    [k0, v0] = fk.split(':'), kv = k0 + ':' + v0 + ':', c0 = kin(cur, kv), nth = c0.indexOf(ae),
    pos = $$('[data-bb-line]', cur).indexOf(had && ae.closest('[data-bb-line]')),
    top = $('[data-bb-cart-scroll]', cur)?.scrollTop, o = S, r = d.importNode(nx, true);
  cur.replaceWith(r);
  S = parse(r);
  lastSync = Date.now();
  const sc = $('[data-bb-cart-scroll]', r), st = S.bands.slotText, sl = $('[data-bb-slot]', r), sm = kin(r, kv),
    keep = sm.length >= c0.length || kin(r, fk.replace(/\d+$/, '')).length;
  if (sc && top) sc.scrollTop = top;
  ensureRecs();
  // Focus: same key, else same kind+variant+occurrence (B2G1 re-splits change keys) unless that line left; then the next title
  if (had) (kin(r, fk).find(e => at(e, 'data-bb-focus') == fk) || keep && (sm[nth] || sm.at(-1))
    || $$('[data-bb-line] [data-bb-focus^="title:"]', r)[pos] || $('[data-bb-cart-title]', r))?.focus({preventScroll: true});
  if (st && st !== o.bands.slotText) {
    if (sl) {
      sl.classList.add('bb-cart-slot--pulse');
      setTimeout(() => sl.classList.remove('bb-cart-slot--pulse'), 600);
    }
    announce(st);
  }
  $$('.js-cart-count').forEach(e => { e.textContent = S.itemCount; e.classList.toggle('hide', !S.itemCount); });
  showNotice(r);
  emit('bb:cart:updated', {item_count: S.itemCount, total_price: S.totalPrice, source: src});
}
const lb = (l, on) => { l.classList.toggle('bb-cart-line--busy', on); on ? l.setAttribute('aria-busy', 'true') : l.removeAttribute('aria-busy'); };

const hdr = (json, get, v = '1') => ({...!get && {Accept: 'application/json'}, 'X-Requested-With': 'XMLHttpRequest', 'X-BB-Cart': v, ...json && {'Content-Type': 'application/json'}});
async function req(url, init, sig) {
  const c = new AbortController(), stop = () => c.abort(), t = setTimeout(stop, 12e3),
    dead = new Promise((_, no) => c.signal.addEventListener('abort', no));
  dead.catch(stop);
  sig?.addEventListener('abort', stop);
  if (sig?.aborted) stop();
  try {
    const r = await Promise.race([W.fetch(url, {...init, signal: c.signal}), dead]),
      j = await r.json().catch(e => { if (c.signal.aborted) throw e; return null; });
    return {ok: r.ok && j != null, status: r.status, json: j};
  } catch {
    return {ok: false, status: 0, timeout: c.signal.aborted && !sig?.aborted};
  } finally {
    clearTimeout(t);
    sig?.removeEventListener('abort', stop);
  }
}

function enqueue(fn, kind) {
  pending++;
  return q = q.then(async () => {
    const ac = jobAC = new AbortController();
    let wd, r;
    try {
      r = await Promise.race([Promise.resolve().then(() => fn(ac.signal)), new Promise(ok => wd = setTimeout(() => { ac.abort(); ok(0); }, 75e3))]);
    } catch (x) { console.warn('[bb-cart]', x); }
    clearTimeout(wd);
    if (r === 0) {
      r = {ok: false, status: 0, timeout: true};
      if (!hidden) enqueue(s => syncNow({signal: s}), 'sync');
    } else if (/^(add|change|update|refresh)$/.test(kind) && stampDue()) enqueue(stampNow, 'stamp');
    pending--;
    return r || {ok: false, status: 0};
  });
}
const busy = () => pending || obsT || obsN;
async function idle(cap) { for (const t = Date.now(); busy() && Date.now() - t < cap;) await wait(50); }

function fail(r, src, form, fb = C.changeError) {
  if (!r.ok && !r.skipped) {
    r.message = r.message || fb;
    emit('bb:cart:error', {message: r.message, status: r.status, source: src, form});
    console.warn('[bb-cart]', r.status);
  }
  return r;
}

function added(r, o, src) {
  if (!fail(r, src, o.form, C.addError).ok) {
    if (!o.form) announce(r.message);
    if (r.landed?.[0] && o.open !== false) openIf(0, src);
    return r;
  }
  const it = r.items || [], t = it.length > 1 ? it.length + ' items have been added to your cart.' : it[0] ? it[0].product_title + ' ' + C.added : '';
  if (t) lastAdd = Date.now();
  emit('bb:cart:added', {items: it, source: src, form: o.form});
  (o.open !== false && !api.skipOpen && !page && !isOpen() ? openDrawer({source: src, trigger: o.trigger}).then(() => wait(750)) : Promise.resolve()).then(() => announce(t));
  return r;
}
const openIf = (prev, src) => prev != cartSig() && !isOpen() && !api.skipOpen && !page && openDrawer({source: src});

/* <jobs> */
// Internal layer: never awaits a queued method (deadlock, §3.4)

async function writeNow(kind, body, o) {
  const fd = body instanceof FormData, sec = {sections: ids, sections_url: location.pathname};
  if (fd) for (const k in sec) body.append(k, sec[k]);
  const r = await req(R[kind] + '.js', {method: 'POST', headers: hdr(!fd), body: fd ? body : JSON.stringify({...body, ...sec})}, o.signal),
    j = r.json, dead = o.signal?.aborted;
  if (r.ok) {
    const h = j.sections?.[ids];
    if (typeof h != 'string') await syncNow(o);
    else if (!dead) swap(h, o.source);
    return {ok: true, status: r.status, items: j.items || (j.id ? [j] : [])};
  }
  const out = {ok: false, status: r.status, timeout: r.timeout,
    message: /^4/.test(r.status) && (j?.description || j?.message) || ''};
  if ((!j || r.status > 499) && !dead) { await syncNow(o); out.synced = 1; }
  return out;
}

// No JSON Accept: Shopify would answer with the page's product/collection/cart JSON instead of the sections.
// o.keep(state): a fresh state it accepts is not drawn (the claim row keeps its busy button and chosen color)
async function syncNow(o = {}) {
  const r = await req(location.pathname + '?sections=' + ids, {headers: hdr(0, 1)}, o.signal), h = r.ok && r.json[ids],
    nx = o.keep && typeof h == 'string' && new DOMParser().parseFromString(h, 'text/html').querySelector('[data-bb-cart-root]');
  if (typeof h != 'string' || o.signal?.aborted) return {ok: false, status: r.status};
  if (!nx || !o.keep(parse(nx))) swap(h, o.source || 'api');
  return {ok: true};
}

async function addNow(input, o = {}, sig) {
  const src = o.source || 'api', w = {signal: sig, source: src};
  let body, hold = 1;
  clearNotice(src);
  // A claim row may be stale (another tab, a drop): re-read, add only if it still holds. A row that holds is not redrawn
  if (src == 'claim' && (await syncNow({...w, keep: s => hold = s.gift.claimable})).ok && !hold) return {ok: false, skipped: true};
  try {
    if (typeof input == 'function') input = input(S);
    body = input instanceof FormData ? input : {items: Array.isArray(input) ? input : input?.items || []};
  } catch { return added({ok: false, status: 0}, o, src); }
  const snap = o.retryMissing && body.items && qmap();
  let r = await writeNow('add', body, w);
  if (r.status == 422 && !sig.aborted) {
    if (snap) r = await retryNow(body.items, snap, r, w);
    else if (src == 'claim') await syncNow(w);
  }
  return sig.aborted ? r : added(r, o, src);
}
async function retryNow(items, snap, r0, w) {
  const want = {}, again = [], miss = v => Math.min(want[v].n, (snap[v] || 0) + want[v].n - (qmap()[v] || 0));
  if (!(await syncNow(w)).ok) return r0;
  items.forEach(it => (want[it.id] = want[it.id] || {it, n: 0}).n += +it.quantity || 1);
  for (const v in want) {
    const p = want[v].it.properties || {};
    if (miss(v) > 0) p._free_gift || p._bb_gift ? noticeNow('gift-sold-out') : again.push({...want[v].it, quantity: miss(v)});
  }
  const r = again.length ? await writeNow('add', {items: again}, w) : {ok: true, items: []};
  if (r.ok) return {...r, partial: true, message: r0.message};
  if (!r.synced) await syncNow(w);
  return {...r0, landed: Object.keys(want).map(v => ({id: +v, quantity: want[v].n - Math.max(0, miss(v))})).filter(x => x.quantity > 0)};
}

async function changeNow(key, qty, o = {}, sig) {
  const src = o.source || 'api', w = {signal: sig, source: src}, tp = typeof qty == 'object' ? qty : 0, k = tp.kind,
    ps = parts(key), g = sumQ(ps), prev = cartSig();
  clearNotice(src);
  if (tp) {
    if (!ps.length) return {ok: true, skipped: true};
    qty = Math.max(0, k ? (k == 'inc' ? g + 1 : g - 1) : g + (+tp.delta || 0));
  }
  let r = await writeNow('change', {id: key, quantity: qty}, w);
  const p2 = parts(key), ln = p2[tp.occ - 1] || p2[0];
  if (r.status == 400 && k && ln) r = await writeNow('change', {line: ln.index, quantity: k == 'inc' ? ln.qty + 1 : ln.qty - 1}, w);
  if (sig.aborted) return r;
  if (r.ok) { if (o.open ?? src == 'link') openIf(prev, src); }
  else if (!k || r.status != 422) {
    if (!r.synced && r.status != 422) await syncNow(w);
    noticeNow('change-error', r.status == 422 && r.message);
  }
  return fail(r, src, o.form);
}

async function updateNow(p, o = {}, sig) {
  const src = o.source || 'api', b = {updates: (p = p || {}).updates};
  if (p.attributes && Object.keys(p.attributes).length) b.attributes = p.attributes;
  clearNotice(src);
  return fail(await writeNow('update', b, {signal: sig, source: src}), src, o.form);
}

async function refreshNow(o = {}, sig) {
  const src = o.source || 'api', prev = cartSig(), r = await syncNow({signal: sig, source: src});
  if (r.ok && o.open == 'ifChanged') openIf(prev, src);
  return fail(r, src);
}
// The engine's only write of its own (§4.15). It never touches a bag line: SMART prices the bag, shopper taps change it (§4.10)
async function stampNow(sig) {
  if (stampDue()) {
    stamped = 1;
    await req(R.update + '.js', {method: 'POST', headers: hdr(1, 0, 'stamp'), body: JSON.stringify({attributes: {_bb_cart: 'v1'}})}, sig);
  }
  return {ok: true};
}
function noticeNow(code, text) {
  const t = text || C[code.replace(/-(\w)/g, (_, c) => c.toUpperCase())];
  if (!t) return;
  notice = {code, text: t};
  showNotice();
  announce(t);
}
/* </jobs> */

const isOpen = () => { const x = dlg(); return !!(x?.open && !x.classList.contains('bb-cart--closing')); };
const visible = e => !!(e?.isConnected && e.getClientRects().length);
const expand = v => $$('[data-behavior="toggle-cart"][aria-controls]').forEach(e => e.setAttribute('aria-expanded', v));
const moved = x => new Promise(r => {
  const p = $('[data-bb-cart-panel]', x), f = e => e.target == p && e.propertyName == 'transform' && end(), end = () => { p?.removeEventListener('transitionend', f); r(); };
  p?.addEventListener('transitionend', f);
  setTimeout(end, 1e3);
});
function slide(x, g = ++gen, f = requestAnimationFrame, go = () => g == gen && x.open) {
  slid = new Promise(r => f(() => f(() => go() ? (d.documentElement.classList.add('bb-cart-lock'), ensureRecs(), f(() => go() ? (x.classList.add('bb-cart--open'), moved(x).then(r)) : r())) : r())));
}

async function openDrawer(o = {}) {
  const x = dlg(), l = $('link[data-bb-cart-css]'), a = d.activeElement;
  if (rebuy()) return;
  if (page) return $('[data-bb-cart-title]', rootEl())?.focus();
  if (!x?.showModal) { location.href = R.cart; return; }
  if (x.open) { x.classList.replace('bb-cart--closing', 'bb-cart--open') && gen++; return; }
  for (let t = 0; l && !l.sheet && t < 2000; t += 50) await wait(50);
  if (x.open || rebuy()) return;
  trig = o.trigger || a != d.body && a;
  try { x.showModal(); } catch { return; }
  x.scrollTo(0, 0);
  shown = 1;
  slide(x);
  expand('true');
  setTimeout(() => {
    const n = S.itemCount;
    if (isOpen() && Date.now() - lastAdd > 2000) announce(C.opening + ' There ' + (n == 1 ? 'is 1 item' : 'are ' + n + ' items') + ' in your cart.');
  }, 750);
  emit('bb:cart:open', {});
}
async function closeDrawer(o = {}) {
  const x = dlg();
  if (!x?.open) return;
  const g = ++gen;
  x.classList.remove('bb-cart--open');
  x.classList.add('bb-cart--closing');
  if (!o.instant && ($('[data-bb-cart-panel]', x)?.getAnimations?.().length ?? 1)) await moved(x);
  if (g == gen && x.open) { x.close(); onClose({target: x}); }
}
function onClose(e) {
  const x = e.target;
  if (!x.matches?.('[data-bb-cart-dialog]') || x.open || !shown) return;
  shown = 0;
  x.classList.remove('bb-cart--open', 'bb-cart--closing');
  d.documentElement.classList.remove('bb-cart-lock');
  expand('false');
  (visible(trig) ? trig : $$('[data-behavior="toggle-cart"]').find(visible))?.focus({preventScroll: true});
  trig = null;
  announce(C.closing);
  emit('bb:cart:close', {});
}

async function ensureRecs() {
  const m = $('[data-bb-cart-recs]', rootEl()), ul = m && $('[data-bb-cart-recs-list]', m), a = S.recs,
    key = S.currency + '|' + a.anchorId, list = recCache.get(key);
  if (!ul || !rc.cartOn) return;
  if (!a.anchorId) return m.hidden = true;
  if (list) {
    ul.innerHTML = list.filter(x => !(a.productIds || []).map(String).includes(x[0])).slice(0, rc.cartMax || 4).map(x => x[1]).join('');
    match(ul, {title: a.anchorVariantTitle, option1: a.anchorOption1});
    m.hidden = !ul.children.length;
    return emit('bb:recs:rendered', {context: 'cart', count: ul.children.length});
  }
  if (!page && !isOpen() || recKey == key) return;
  recAC?.abort();
  const c = recAC = new AbortController(), t = setTimeout(() => c.abort(), 8e3);
  let l2 = [];
  recKey = key;
  try {
    const res = await fetch(R.recs + '?product_id=' + a.anchorId + '&limit=10&section_id=' + secs.cartRecs + '&intent=related', {signal: c.signal});
    if (!res.ok) throw res.status;
    l2 = pick($$('[data-bb-recs-payload] [data-bb-rec]', new DOMParser().parseFromString(await res.text(), 'text/html')),
      {...a, aliases: rc.aliases, max: 12}).map(n => [at(n, 'data-product-id'), n.outerHTML]);
  } catch (x) {
    if (c == recAC && !recWarned) { recWarned = 1; console.warn('[bb-recs]', +x || 0); }
  }
  clearTimeout(t);
  if (c != recAC) return;
  recAC = recKey = null;
  recCache.set(key, l2);
  await slid;
  ensureRecs();
}

const hasBB = h => !!h && new Headers(h).has('X-BB-Cart');
function obsMatch(input, init = {}) {
  const rq = input instanceof Request, p = new URL(rq ? input.url : input, location.href).pathname, disc = p.includes('/discount/');
  if (hasBB(init.headers) || rq && hasBB(input.headers)) return;
  if (disc || /^post$/i.test(init.method || rq && input.method) && /\/cart\/(add|change|update|clear)(\.js|\.json)?$/.test(p)) return {disc};
}
function observed(m) {
  obsN--;
  obsOpen = obsOpen || !m.disc;
  clearTimeout(obsT);
  obsT = setTimeout(() => {
    const open = obsOpen ? 'ifChanged' : 'never';
    obsT = obsOpen = 0;
    enqueue(s => refreshNow({source: 'external', open}, s), 'refresh');
  }, 250);
}
function observe() {
  const F = W.fetch, X = XMLHttpRequest.prototype, open = X.open, send = X.send;
  W.fetch = function (input, init) {
    const p = F.apply(this, arguments);
    try { const m = obsMatch(input, init); if (m) { obsN++; p.then(() => observed(m), () => observed(m)); } } catch {}
    return p;
  };
  X.open = function (m, u) {
    try { this.__bbObs = obsMatch(u, {method: m}); } catch { this.__bbObs = 0; }
    return open.apply(this, arguments);
  };
  X.send = function () {
    const m = this.__bbObs;
    if (m) { obsN++; this.addEventListener('loadend', () => observed(m)); }
    return send.apply(this, arguments);
  };
}

const ok = (f, re) => !rebuy() && !f.closest('[data-bb-cart-ignore]') && re.test(new URL(at(f, 'action') || '', location.href).pathname),
  mine = (e, f, s, tg = at(f, 'target')) => !e.defaultPrevented && ok(f, ADD) && !(tg && tg != '_self') && !s?.hasAttribute('formaction');
function onSubmit(e) {
  const f = e.target, s = e.submitter;
  ok(f, CART) ? hold(e, f) : mine(e, f, s) && take(e, f, s);
}
// An add is taken at its submit control's click, in the bubble phase (the control's own handlers may cancel it first),
// so no submit fires (Shopify's analytics would count it twice, QM-25). Disabled or invalid: left to the browser.
// bb:cart:submit stands in for the submit event (BOTM)
function onPress(e) {
  const s = e.target.closest?.('button,input'), f = s?.form;
  if (f && /^(submit|image)$/.test(s.type) && !s.matches(':disabled') && (f.noValidate || s.formNoValidate || !f.matches(':invalid')) && mine(e, f, s)) {
    emit('bb:cart:submit', {form: f, submitter: s});
    take(e, f, s);
  }
}
function take(e, f, s) {
  e.preventDefault();
  if (f.dataset.bbBusy) return;
  let fd;
  try { fd = new FormData(f, s); } catch { fd = new FormData(f); if (s?.name) fd.append(s.name, s.value); }
  const rec = f.hasAttribute('data-bb-rec-form'), claim = f.hasAttribute('data-bb-claim-form'),
    b = (rec || claim) && (s || $('button[type="submit"]', f)), lbl = k => { if (b) b.textContent = b.dataset[k]; };
  errs.get(f)?.remove();
  f.dataset.bbBusy = 1;
  f.setAttribute('aria-busy', 'true');
  if (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); lbl('busy'); }
  api.add(fd, {source: claim ? 'claim' : rec ? 'recs-' + (f.dataset.bbRecContext == 'pdp' ? 'pdp' : 'cart') : 'form', form: f, trigger: b}).then(r => {
    delete f.dataset.bbBusy;
    f.removeAttribute('aria-busy');
    if (b) {
      b.disabled = false;
      b.removeAttribute('aria-busy');
      lbl(r.ok ? 'done' : 'label');
      if (r.ok) setTimeout(() => b.textContent == b.dataset.done && lbl('label'), 2000);
    }
    const m = r.message || C.addError;
    if (r.ok) return;
    if (rec) say($('[data-bb-rec-error]', f.closest('[data-bb-rec]') || f), m);
    else if (claim) say($('[data-bb-claim-error]', rootEl()), r.status == 422 ? C.giftSoldOut : C.addError);
    else {
      const p = mk('p', 'bb-cart-form-error', m);
      p.setAttribute('role', 'alert');
      f.append(p);
      errs.set(f, p);
      setTimeout(() => p.remove(), 8e3);
    }
  });
}
async function hold(e, f) {
  const s = e.submitter;
  if (e.defaultPrevented || s?.name != 'checkout') return;
  ckBusy(s);
  if (f.dataset.bbPass) return delete f.dataset.bbPass;
  if (!busy() && !loop()) return;
  e.preventDefault();
  await idle(4000);
  const b = s.isConnected ? s : $('[data-bb-checkout]', rootEl()), f2 = b?.form;
  if (!f2) return;
  ckBusy(b);
  if (!S.itemCount) return ckBusy();
  if (loop()) return W.LoopOnstore.submit();
  f2.dataset.bbPass = 1;
  try { f2.requestSubmit(b); } catch { b.click(); }
}
function ckBusy(b) {
  const x = b || $('[data-bb-checkout]', rootEl()), l = x && $('[data-bb-checkout-label]', x), sp = mk('span', 'bb-cart-spin', '');
  if (!l) return;
  if (ckText == null) ckText = l.textContent;
  sp.setAttribute('aria-hidden', 'true');
  b ? l.replaceChildren(sp, ' ' + C.checkoutBusy) : l.textContent = ckText;
  b ? x.setAttribute('aria-busy', 'true') : x.removeAttribute('aria-busy');
}

function onClick(e) {
  const t = e.target;
  if (!t.closest || rebuy() || e.defaultPrevented || t.closest('[data-bb-cart-ignore]')) return;
  const a = t.closest('a[href]'), qb = t.closest('[data-bb-qty]');
  if (t.matches('.bb-cart--open[data-bb-cart-dialog]')) return closeDrawer();
  if (qb?.closest('[data-bb-cart-root]')) return step(e, qb);
  if (t.closest('[data-bb-cart-submit-main-form]')) return treePlanted(e);
  if (t.closest('[data-bb-cart-close],[data-cart-close]')) return closeDrawer();
  if (a && (e.button || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || link(e, a))) return;
  const o = t.closest('[data-behavior="toggle-cart"],[data-bb-cart-open],[data-cart-open]');
  if (o) { e.preventDefault(); openDrawer({trigger: o, source: 'link'}); }
}
function link(e, a) {
  const p = a.pathname, sp = new URLSearchParams(a.search), id = sp.get('id'), qt = sp.get('quantity'),
    only = /^id(,quantity)?$/.test([...sp.keys()].sort()), verb = VERB.exec(p)?.[3], dec = at(a, 'data-bb-cart-dec');
  let go;
  if (a.origin != location.origin) return true;
  if (CART.test(p) && !a.search) go = () => openDrawer({trigger: a, source: 'link'});
  else if (verb == 'add' && only && /^\d+$/.test(id) && (qt == null || /^[1-9]\d*$/.test(qt))) go = () => api.add([{id: +id, quantity: +qt || 1}], {source: 'link'});
  else if (verb == 'change' && dec) go = () => api.change(dec, {delta: -1}, {source: 'link', open: true});
  else if (verb == 'change' && only && id?.includes(':') && /^\d+$/.test(qt)) go = () => api.change(id, +qt, {source: 'link', open: true});
  else return false;
  e.preventDefault();
  go();
  return true;
}

function step(e, b) {
  const line = b.closest('[data-bb-line]'), kind = at(b, 'data-bb-qty'), key = at(b, 'data-key'), vid = parts(key)[0]?.variantId,
    occ = +at(b, 'data-bb-focus')?.split(':').pop() || 1, ui = on => { b.classList.toggle('bb-cart-qty__btn--busy', on); lb(line, on); };
  e.preventDefault();
  if (!key || !line || at(line, 'aria-busy')) return;
  ui(true);
  say($('[data-bb-line-error]', line), '');
  const t = $('[data-bb-focus^="title:"]', line)?.textContent.trim() || 'Item';
  enqueue(s => changeNow(key, {kind, occ}, {source: 'stepper'}, s), 'change').then(r => {
    const n = sumQ(S.lines.filter(l => l.variantId == vid));
    ui(false);
    if (r.ok && !r.skipped) announce(n ? `${t} quantity ${n}. Subtotal ${(S.totalPrice / 100).toLocaleString(void 0, {style: 'currency', currency: S.currency || 'USD'})}.` : t + ' removed from your cart.', 1);
    if (r.status != 422) return;
    const ln = $$('[data-bb-line]', rootEl()).filter(x => at(x, 'data-key') == key)[occ - 1], el = ln && $('[data-bb-line-error]', ln);
    say(el, r.message);
    setTimeout(() => say(el, ''), 8e3);
  });
}
function treePlanted(e) {
  const f = $('main .js-product-form'), b = f && $('button[type="submit"]', f);
  e.preventDefault();
  $('#tree-planted [data-behavior="close-modal"]')?.click();
  b ? b.click() : f?.requestSubmit();
}

function standDown() {
  if (rebuy() && !warned) { warned = 1; console.warn('[bb-cart] Rebuy Smart Cart detected; native cart standing down'); }
}

observe();
const qs = new URLSearchParams(location.search);
d.addEventListener('submit', onSubmit);
d.addEventListener('click', onPress);
d.addEventListener('click', onClick);
d.addEventListener('change', e => e.target.matches?.('[data-bb-variant-select]') && !e.target.closest('[data-bb-cart-ignore]') && vSync(e.target, 1));
d.addEventListener('cancel', e => { if (e.target.matches?.('[data-bb-cart-dialog]')) { e.preventDefault(); closeDrawer(); } }, true);
d.addEventListener('close', onClose, true);
S = parse(rootEl());

const api = W.BBCart = {
  version: '1',
  get state() { return S; },
  skipOpen: [].concat(cfg.skipOpen || []).some(s => (s = String(s).trim()) && location.href.includes(s)),
  add: (i, o) => enqueue(s => addNow(i, o, s), 'add'),
  change: (k, n, o) => enqueue(s => changeNow(k, n, o, s), 'change'),
  update: (p, o) => enqueue(s => updateNow(p, o, s), 'update'),
  refresh: o => enqueue(s => refreshNow(o, s), 'refresh'),
  open: openDrawer,
  close: closeDrawer,
  isOpen,
  notice: noticeNow,
  recs: {pick, match}
};
emit('bb:cart:ready', {state: S});
if (stampDue()) enqueue(stampNow, 'stamp');
if (page) ensureRecs();

function ready() {
  standDown();
  if (!page && (qs.get('viewcart') == 'true' || qs.get('viewcart_if_items') == 'true' && S.itemCount > 0)) openDrawer({source: 'deeplink'});
  addEventListener('pagehide', () => {
    hidden = 1;
    jobAC?.abort();
    $$('form[data-bb-busy]').forEach(f => { delete f.dataset.bbBusy; f.removeAttribute('aria-busy'); });
    closeDrawer({instant: true});
  });
  addEventListener('pageshow', e => {
    if (!e.persisted) return;
    hidden = 0;
    ckBusy();
    api.refresh({source: 'pageshow', open: 'never'});
  });
  d.addEventListener('visibilitychange', () => d.visibilityState == 'visible' && Date.now() - lastSync >= 1e4 && api.refresh({source: 'visibility', open: 'never'}));
  d.addEventListener('shopify:section:load', e => e.detail?.sectionId == ids && (S = parse(rootEl())));
}
d.readyState == 'loading' ? d.addEventListener('DOMContentLoaded', ready) : ready();
addEventListener('load', standDown);
})();
